/**
 *
 * Asynchronously loads the component for SiteMap
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
